export default () => {
    return <div className="w-full flex justify-center">
        <img src="/images/Cook-A-Geddon_logo.png" className="w-10/12 pointer-events-none lg:ml-12" style={{maxWidth: '650px'}} />
    </div>;
}
